import { Folder } from "../../../models/site-content/folder.model";
import { HomePageActionDialogReturnObj, PerformActionParamObj } from "../extras";
import { HomePageActionBase } from "./home-page-base-action";
import { IHomePageAction } from "./i-home-page-action";

export class CreateFolderAction extends HomePageActionBase implements IHomePageAction {

    public getTitle() {
        return "Create Folder";
    }

    public permissionsRequiredToPerform(): string {
        return "CanCreateFolder"
    }

    public requiresTree(): boolean {
        return true;
    }

    public requiresWritableRootNode(): boolean {
        return true;
    }

    public hasDoneMessage(): boolean {
        return true;
    }

    public performAction(paramObj: PerformActionParamObj): Promise<HomePageActionDialogReturnObj> {
        let entityName = paramObj.entityName;
        let folderId = paramObj.folderId;

        this.message = "Creating Folder...";
        let newFolder = new Folder();
        newFolder.name = entityName;
        newFolder.parentFolderId = folderId;
        newFolder.dataCollectionId = this.siteId;
        return this.folderService.create(newFolder).then(x => {
            this.message = `Created a Folder called "${entityName}" in Folder "${paramObj.parentFolderName}"`;
            return new HomePageActionDialogReturnObj();
        });
    }

}
